import Vue from "vue";
import {
  NavBar,
  Form,
  Field,
  Button,
  Tabbar,
  TabbarItem,
  Icon,
  Tabs,
  Tab,
  Cell,
  List,
  PullRefresh,
  ActionSheet,
  Popup,
  Row,
  Col,
  Badge,
  Image as VanImage,
  Checkbox,
  CheckboxGroup,
  DropdownMenu,
  DropdownItem,
  RadioGroup,
  Radio,
} from "vant";
Vue.use(NavBar);
Vue.use(Form);
Vue.use(Field);
Vue.use(Button);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Icon);
Vue.use(Tabs);
Vue.use(Tab);
Vue.use(Cell);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(ActionSheet);
Vue.use(Popup);
Vue.use(Col);
Vue.use(Row);
Vue.use(Badge);
Vue.use(VanImage);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
